module.exports = __webpack_public_path__ + "resource/img/banner_about.jpg?9870fb3fb4e12feda599b4382d5752e3";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_about.jpg
// module id = 190
// module chunks = 36